import Selector from "../../components/common/selector";
import UploadFile from "../../components/common/uploadFile";
import React, {useEffect, useState} from "react";
import {fetchSchools} from "../../actions/schools";
import {useDispatch, useSelector} from "react-redux";

const UploadTab = (props) => {
  const {
    activeTab,
    onSubmitAction,
    school,
    changeSchool,
    selectSchools,
    schoolError,
    submitDisabled
  } = props;

  //Don't allow button to be clicked if already clicked or data is missing
  const canUpload = (!submitDisabled && (school && activeTab.canUpload));

  const isOptionDisabled = (school) => {
    return school.accessDataStatus === 'Final' || school.accessDataStatus === 'Processing' || school.accessDataStatus === 'Queued' || school.accessDataStatus === 'Uploaded';
  }

  return (
    <div className='upload-tab-container'>
      <div className='upload-form'>
        <form name='uploadData' onSubmit={(e) => {e.preventDefault(); onSubmitAction(school)}}>
            <div className='upload-tab-header'>{activeTab.label}</div>
            <div className='upload-form-row'>
              <span className='upload-step-number'>1.</span>
              <div className='upload-instructions'>
                {activeTab.instructions}
              </div>
            </div>
            <div className='upload-form-row'>
              <span className='upload-step-number'>2.</span>
              <Selector
                name='schools'
                label='Select School'
                showLabel={false}
                value={school.id}
                optionValueField='id'
                optionLabelField='name'
                isOptionDisabled={isOptionDisabled}
                items={selectSchools}
                changeAction={changeSchool}
                errors={[schoolError]}
                focusOnError={schoolError}
              />
            </div>
            <div className='upload-form-row'>
              <span className='upload-step-number'>3.</span>
              <div className='uploadFiles'>
                {activeTab.uploads.map((upload) => {
                  return (
                    <div className='upload-file'>
                      <UploadFile label={upload.label} name={upload.name} note={upload.note} onChange={upload.onChange} noFileMessage={(!upload.uploadFile && school ? upload.noFileMessage : '')} error={upload.error}/>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className='upload-submit-row'>
              <span className='upload-step-number'>4.</span>
              <button className='tes-button' disabled={!canUpload}>Submit</button>
            </div>
        </form>
      </div>
      <div className='sideImage'>
        <img src={activeTab.sideImage} alt={activeTab.sideImageAlt} height='150' width='150'/>
      </div>
    </div>
  );
};

export default UploadTab;